import React, { useState, useEffect } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
// import { logout } from "../../redux/actions/login";
import Navbar from './shared/navbar';
import Sidebar from './shared/sidebar';
import Footer from './shared/footer';

import { useSelector, useDispatch } from 'react-redux';
import './shared/shared.css';
import { authenticateUser } from '../../redux/actions/authenticate';


const PrivateRoute = ({ component: Component, restricted, ...rest }, props) => {
    let dispatch = useDispatch();
    // let getArn = useSelector(state => state.Auth.arnDetails);
    const [option, setOption] = useState([

        { menu: { label: 'Invest Now', linkTo: `/purchase`, class: "etf-transact" }, },
        { menu: { label: 'Order Book', linkTo: `/orderbook`, class: "report_navicon" }, },
    ])
    let locationPath = rest.location.pathname;// currentUrl e.g. /dashboard/systematicPlan, /dashboard/transcat/invest

    useEffect(() => {
        dispatch(authenticateUser())
    }, [])


    const logoutClick = () => {
        // dispatch(logout())
    }

    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        <React.Fragment>
            <div className="container-scroller">
                <Navbar logout={logoutClick} />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar option={option} />
                    <div className="main-panel">
                        <div className="content-wrapper">
                            <Route {...rest} render={props => (<Component {...props} {...rest} />)} />
                        </div>
                        <Footer />
                    </div>
                </div>

            </div>
        </React.Fragment>
    );
};

export default withRouter(PrivateRoute)

